// export default () => ({
// })

export default () => ({
    clients: [],
    clientsSelectable: [],
    clientSelect: null,
    clientsPaginatedData: null,
    client: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null,

    isLoadingClientProducts: false,
    clientProducts: [],
    clientInputsLength: 0,
    clientOutputsLength: 0
})